import { Box, Button, IconButton } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { APIRoutes, PageRoutes } from "../../../../../Utils/constant";
import HttpService from "../../../../../Hooks/Https-services";
import { useLoadData } from "../../../../../Context/LoadDataContext";
const ActionButtons = ({ data }: any) => {
  const navigate = useNavigate();
  const { handleRefresh } = useLoadData();
  const handleActiveInActive = async () => {
    try {
      const res = await HttpService.post(
        APIRoutes.ActiveInActiveDelete.replace(":id", data?.row?.id),
        {
          active: data?.row?.is_active ? false : true,
          delete_d: false,
        }
      );
      handleRefresh();
    } catch (error) {}
  };
  const handeDelete = async () => {
    try {
      const res = await HttpService.post(
        APIRoutes.ActiveInActiveDelete.replace(":id", data?.row?.id),
        {
          active: false,
          delete_d: true,
        }
      );
      handleRefresh();
    } catch (error) {}
  };
  return (
    <Box>
      <IconButton
        onClick={() =>
          navigate(PageRoutes.BumperVideo.replace(":id", data?.row?.id))
        }
      >
        <EditIcon />
      </IconButton>
      <IconButton onClick={handeDelete}>
        <DeleteIcon color="error" />
      </IconButton>
      <Button onClick={handleActiveInActive} variant="contained">
        {!data?.row?.is_active ? "Make Active" : "Make Inactive"}{" "}
      </Button>
    </Box>
  );
};
export default ActionButtons;
